module.exports = __webpack_public_path__ + "img/media-5.05db648b.png";